import React, {useState, useEffect} from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import {Button}  from 'react-bootstrap'

const styles = {
  p: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '.5rem 1rem',
      border: '1px solid #ccc',
      borderRadius: '4px',
      marginBottom: '.5rem'
  }
}

function Dogs() {
  let [dogImage, setDogImage] = useState([])
  let [updateImage, setUpdateImage] = useState(0)

  useEffect(() => {
    fetch("https://dog.ceo/api/breeds/image/random/3")
    .then(response => response.json())
        // 4. Setting *dogImage* to the image url that we received from the response above
    .then(data => { setDogImage(data.message)
    // console.log(data.message)
    })
  }, [updateImage])

    return (
      <div className="dogs">
        <h1>Dogs image API</h1>
        <p>(API: https://dog.ceo/api/)</p>

        <Button 
          variant="secondary"
          onClick={() => setUpdateImage(updateImage+1)} 
        >
         Next ...
        </Button>
        <br/>
        <br/>
        <div style={styles.p} >
          {dogImage.map((dog, ind) => (<img height={"200px"} src={dog} key={dog} title={ind+1} alt=""></img>))}
        </div>
    </div>
    )
  }
  
  export default Dogs